import { AfterContentInit, OnDestroy, OnInit, ElementRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { finalize, mergeMap } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { PlycaDataService } from '../../../services/plyca.service';
import { FieldConfig } from '../../api/contract-notice-dto';
import { DOCUMENT_SELECTION_MODE } from '../../api/plyca-dtos';
import { ExportProcessDTO, ExportProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { Configuration } from '../../conf/app.constants';
import { DocumentService } from '../../documents/document.service';
import { ServiceLocator } from '../../ServiceLocator';
import { UIService, generateRandomIdentifier } from '../../ui.service';




@Component({
  selector: 'exportProcessEditionPanel',
  templateUrl: 'exportProcessEditionPanel.template.html',
  providers: [UIService]

})
export class exportProcessEditionPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy, OnInit {


  public NAME_FIELD = 'name';
  public DESCRIPTION_FIELD = 'description';
  public CONFIGURATIONS_FIELD = 'configuration';
  private identifier: string;
  exportProcess: ExportProcessDTO;
  configurations: Array<any>;

  loaded = false;

  public windowHash: string;


  documentService: DocumentService;
  plycaService: PlycaDataService;
  waitService: WaitLoadingService;
  configuration: Configuration;
  //view audit
  selectedProjectEntity: any;
  displayExportProcessAudit = false;
  private plycaErrorHandler: PlycaErrorHandler;
  uiService: UIService;
  translateService: TranslateService;
  public readonly = false;
  duplicate = false;










  constructor(
    public elem: ElementRef,
    public helpService: HelpService,
    public headerActionsService: HeaderActionsService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig
  ) {
    super();
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);
    this.configuration = ServiceLocator.injector.get(Configuration);
    this.plycaErrorHandler = ServiceLocator.injector.get(PlycaErrorHandler);
    this.uiService = ServiceLocator.injector.get(UIService);
    this.translateService = ServiceLocator.injector.get(TranslateService);

    this.waitService.startWaiting();

    this.documentService = ServiceLocator.injector.get(DocumentService);

    this.windowHash = generateRandomIdentifier();
    this.identifier = this.dialogConfig['id'];
    this.exportProcess = this.dialogConfig['exportProcess'];
    this.duplicate = this.dialogConfig['duplicate'];

    if (this.dialogConfig['readonly'] !== undefined && this.dialogConfig['readonly'] === true) {
      this.readonly = true;
    } else {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.EDIT_EXPORTPROCESS));
    }
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.readonly) {
      this.subscribe(this.headerActionsService.addWindowAction('General.accept', 'fas fa-check', 'btn-primary', true, this.windowHash)
        ,
        () => {
          console.log('INVOCANDO A SAVE')
          this.save();
        });
    }
    this.subscribe(this.headerActionsService.addWindowAction('General.close', 'fas fa-times', 'btn-secondary', true, this.windowHash)
      ,
      () => {

        this.ref.close();
      });

    this.load();
  }
  ngOnInit() {
    console.log('Init');


  }
  ngAfterContentInit(): void {
    //this.headerActionsService.setTaskDescription(this.elem, 'ExportProcesses.title', 'fa fa-cloud-download', this.isLoaded.bind(this));


    // this.headerActionsService.addWindowDivider(this.windowHash);
    // this.addBackAction();
  }

  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12';
    config.jsonField = name;
    if (name === this.NAME_FIELD) {
      config.type = 'STRING';
      config.description = this.translateService.instant('Documents.export.process.data.name') + ':';
    } else if (name === this.DESCRIPTION_FIELD) {
      config.type = 'TEXTAREA';
      config.description = this.translateService.instant('Documents.export.process.data.description') + ':';
    } else if (name === this.CONFIGURATIONS_FIELD) {
      config.type = 'DROPDOWN';
      config.description = this.translateService.instant('Documents.export.process.data.configuration') + ':';
      config.dropDownDataKey = 'name';
      config.data = this.configurations;
    }
    config.editable = !this.readonly;
    return config;
  }

  load() {
    this.subscribe(this.plycaService.getExportProcessesConfigurations().pipe(finalize(() => {
      this.loadExportProcess();


    })), results => {
      this.configurations = [];
      results.forEach(r => {
        this.configurations.push({ label: r['name'], value: r });
      });

    });

  }

  loadExportProcess() {
    if (this.exportProcess != undefined) {
      this.loaded = true;
      this.waitService.cancelWaiting();
    } else if (this.identifier) {

      this.subscribe(this.plycaService.get<ExportProcessDTO>(this.configuration.EXPORTPROCESS_SERVICE_URL, this.identifier)
        .pipe(finalize(() => {
          this.waitService.cancelWaiting();

          this.loaded = true;
        }))
        , result => {
          console.log(result);
          this.exportProcess = result;
          this.patchConfiguration(result, this.configurations);
          if (this.duplicate) {

            this.exportProcess.name = this.translateService.instant('ExportProcesses.copy.name') + this.exportProcess.name;
          }


        });
    }
  }

  patchConfiguration(result: ExportProcessDTO, configurations: Array<any>) {
    // Al recuperar la exportacion no tenemos el nombre y la descripcion dela configuracion utilizada.
    // BUscamos una configuracion cuyos parametros sean iguales a los de la exportacion
    configurations.forEach(config => {
      let exportConf = config.value;
      if (exportConf.documentFileSelectionMode === result.configuration.documentFileSelectionMode &&
        exportConf.exportFormat === result.configuration.exportFormat &&
        exportConf.includeCommunicationDocuments === result.configuration.includeCommunicationDocuments &&
        exportConf.includeOnlyCurrentDocumentVersion === result.configuration.includeOnlyCurrentDocumentVersion &&
        exportConf.includeOnlyPrincipalDocumentVersions === result.configuration.includeOnlyPrincipalDocumentVersions &&
        exportConf.includeOnlySignedDocuments === result.configuration.includeOnlySignedDocuments &&
        exportConf.includeTemporalDocumentVersion === result.configuration.includeTemporalDocumentVersion) {
        result.configuration = exportConf;
      }
    });
  }

  save() {
    if (this.duplicate) {
      this.exportProcess.identifier = undefined;
      this.exportProcess.execution = undefined;


    }
    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .createExportProcess(this.exportProcess)
      .pipe(mergeMap(_exportProcess => {
        return this.plycaService.getExportProcess(_exportProcess.identifier)
      }), finalize(() => {
        this.waitService.cancelWaiting();

      })), result => {
        console.log('EXPORTACION CREADA', result);
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(
          this.translateService.instant('Documents.export.process.success')
          + ':<br><b>'
          + result.description + '(' + result.identifier + ')</br>',
          this.translateService.instant('General.info'),
          'success');
        this.ref.close();
      },
      (error: any) => {
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error)
      });
  }

  viewAudit(exportProcessProjectEntity: ExportProjectEntityDTO) {
    this.selectedProjectEntity = exportProcessProjectEntity;
    this.displayExportProcessAudit = true;
  }

  viewDocuments(exportProcessProjectEntity: ExportProjectEntityDTO) {
    let selectedDocs = [];
    exportProcessProjectEntity.exportDocuments.forEach(doc => selectedDocs.push(doc.document));
    this.documentService.openDossierDocumentsDialog(exportProcessProjectEntity.projectEntity.identifier,
      this.translateService.instant('Documents.export.process.title') + ' #' + this.identifier,
      undefined, DOCUMENT_SELECTION_MODE.SELECTION_MODE_MULTIPLE_SELECTION, selectedDocs, true);
  }
  ngOnDestroy(): void {
    this.uiService = null;
    this.dialogConfig = null;
    //this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  countExport(exportDocuments: Array<any>) {
    try {
      return exportDocuments.filter(docs => docs.exportResult.isProcessed).length;
    } catch { return 0; }
  }

}